import * as React from "react"
import { preventNumberInputWheel } from "helpers/preventNumberInputWheel"
import { cn } from "../../lib/utils"
export interface InputProps
 extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
 ({ className, type, onFocus, onWheel, inputMode, value, placeholder, ...props }, ref) => {
 const isNumeric = type === "number" || inputMode === "numeric" || inputMode === "decimal"
const shouldHideZero =
 isNumeric &&
 !props.readOnly &&
 !props.disabled &&
 (value === 0 || value === "0")
 return (
 <input
 type={type}
 className={cn(
"flex h-10 w-full rounded-xl border border-border-subtle bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/30 focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:bg-muted disabled:text-muted-foreground dark:bg-[hsl(var(--surface-elevated))] dark:ring-offset-card transition-shadow duration-150",
 className
 )}
 ref={ref}
 inputMode={inputMode}
 value={shouldHideZero ? "": value}
 placeholder={placeholder ?? (shouldHideZero ? "0": undefined)}
 onFocus={(e) => {
 if (isNumeric) {
 try {
 e.currentTarget.select()
 } catch {
 // ignore
 }
 }
 onFocus?.(e)
 }}
 onWheel={(e) => {
 if (type === "number") {
 preventNumberInputWheel(e)
 }
 onWheel?.(e)
 }}
 {...props}
 />
 )
 }
)
Input.displayName ="Input"
export { Input }
